import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";

interface PublicLeagueCardProps {
  league: {
    id: string;
    name: string;
    emoji: string | null;
    member_count: number | null;
    description: string | null;
  };
  onJoin: (id: string, name: string) => void;
}

const PublicLeagueCard = ({ league, onJoin }: PublicLeagueCardProps) => (
  <Card>
    <CardContent className="flex items-center gap-3 p-4">
      <span className="text-3xl flex-shrink-0">{league.emoji || "🏆"}</span>
      <div className="flex-1 min-w-0">
        <p className="font-semibold truncate">{league.name}</p>
        <p className="text-xs text-muted-foreground flex items-center gap-1">
          <Users className="h-3 w-3" /> {league.member_count ?? 0} members
        </p>
      </div>
      <Button size="sm" onClick={() => onJoin(league.id, league.name)}>Join</Button>
    </CardContent>
  </Card>
);

export default PublicLeagueCard;
